
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import { SlashNConverter, FluctuationColor } from '~/utils/'


export default {
    props: {
        conData: {
            type: [Number, String, Object, Array],
        },
    },
    data() {
        return {
            componentKey: 0,
            html: '',
            lastUpdate: ''
        }
    },
    computed : {
        ...mapState ({
            isEarning : state => state.board.isEarning,
        }),
    },
    watch: {
        conData() {
            this.html = ''
            // rerender 문제 해결 방법
            console.log('updated')
            // console.warn('condata', this.conData) 

            // 22.09.28 suye 주요기업실적 
            if(this.isEarning && this.conData[0] && this.conData[0].nextKey !== undefined) {
                // console.warn('CAME IN condata', this.conData, 'len=', this.conData.length)
                this.html = this.conData[0].content
            } else if (this.isEarning && this.conData && this.conData.nextKey !== undefined){
                // console.warn('CAME IN condata2 ', this.conData.nextKey)
                this.html = this.conData.content
            }
            else { 

                for (let i = 0; i < this.conData.length; i++) {
                if (i !== 0) {
                    /* 
                        2204012 meej title 마다 hr 추가 
                    */
                    const title = `<p style="font-weight: bold;">[${this.conData[i].title}]</p>`
                    this.html += '<hr>' + title // + '<br>'
                }
                if (this.conData[i].DIVISION === 'EX1') {
                    // this.html
                    // 20211102 shb
                    // (+0.150YEN),(+0.0005EURO)
                    const regex = new RegExp('(?<=\\()[\\-\\+].+?(?=\\))', 'g')
                    const result = this.conData[i].content.match(regex)
                    if (result !== null) {
                        result.forEach((el) => {
                            if (el.charAt(0) === '+') {
                                const tagStr = `<nobr style="color: red">${el}</nobr>`
                                this.conData[i].content = this.conData[
                                    i
                                ].content.replaceAll(el, tagStr)
                            } else if (el.charAt(0) === '-') {
                                const tagStr = `<nobr style="color: blue">${el}</nobr>`
                                this.conData[i].content = this.conData[
                                    i
                                ].content.replaceAll(el, tagStr)
                            }
                        })
                    }
                }
                
                // 22.08.17 suye 일본 마감지수 엔화 값 색반영 안되는 것 처리
                // ex. 마감지수 : 니케이225 28,110.39엔(+70.23엔/+0.25%)
                if(this.conData[i].content.includes('니케이')){
                    const regex = new RegExp('(?<=\\()[\\-\\+].+?(?=\\))', 'gi')
                    const result = this.conData[i].content.match(regex)
                    if (result !== null) {
                        result.forEach((el) => {
                            if (el.includes('엔')) {
                                if (el.charAt(0) === '+') {
                                    el = el.split('/')[0]
                                    const tagStr = `<nobr style="color: red">${el}</nobr>`
                                    this.conData[i].content = this.conData[
                                        i
                                    ].content.replaceAll(el, tagStr)
                                } else if (el.charAt(0) === '-') {
                                    el = el.split('/')[0]
                                    const tagStr = `<nobr style="color: blue">${el}</nobr>`
                                    this.conData[i].content = this.conData[
                                        i
                                    ].content.replaceAll(el, tagStr)
                                }
                            }
                        })
                    }
                }

                this.html += FluctuationColor(
                    SlashNConverter(this.conData[i].content)
                )
            }
            this.forceRerender()
            // 22.04.01 suye 작성일자 추가 
            for (let i = 0; i < this.conData.length; i++) {
            const lastTimeDate = this.conData[i].lastUpdateTime
            const stringDate = lastTimeDate.substring(0, 4) + '/' + lastTimeDate.substring(4, 6) + '/' + 
            lastTimeDate.substring(6, 8) + ' ' + lastTimeDate.substring(8, 10) + ':' + lastTimeDate.substring(10, 12)
            console.log('lastTimeDate: ', stringDate)
            this.lastUpdate = stringDate
            }

            }   

        },
    },
    methods: {
        // 하위 컴포넌트 렌더링 문제
        forceRerender() {
            this.componentKey += 1
        },
        // SlashNConverter() {
        //   if (this.conData[0] !== undefined) {
        //     // console.log(this.conData.content + 'ddddddd')
        //     this.html = this.conData[0].content.replace(/\n/gi, '<br>')
        //   }
        // },

        // lastTime(){
        //     for (let i = 0; i < this.conData.length; i++) {
        //         const lastTimeDate = this.conData[i].lastUpdateTime
        //         const stringDate = lastTimeDate.substring(0, 4) + '/' + lastTimeDate.substring(4, 6) + '/' + 
        //         lastTimeDate.substring(6, 8) + ' ' + lastTimeDate.substring(8, 10) + ':' + lastTimeDate.substring(10, 12)
        //         console.log('lastTimeDate: ', stringDate)
        //         this.lastUpdate = stringDate
        //     }
        // },
    },
}
